export class MultiPanelElement {

    /**
     * @param {HTMLElement} element
     */
    constructor(element) {
        this._element = element;
        this._onHashChange = this._onHashChange.bind(this);
        this._onDocumentClick = this._onDocumentClick.bind(this);
        window.addEventListener('hashchange', this._onHashChange);
        document.addEventListener('click', this._onDocumentClick);
    }

    get activePanel() {
        throw new TypeError('getter `activePanel` is not implemented');
    }

    set activePanel(value) {
        throw new TypeError('setter `activePanel` is not implemented');
    }

    get panels() {
        return Array.from(this._element.querySelectorAll('[role=tabpanel]'));
    }

    openPanel(panel, targetState) {
        this.activePanel = targetState ? panel : null;
    }

    destroy() {
        window.removeEventListener('hashchange', this._onHashChange);
        document.removeEventListener('click', this._onDocumentClick);
    }

    /**
     * @param {MouseEvent} e
     * @private
     */
    _onDocumentClick(e) {
        const link = e.target.closest && e.target.closest('a[href*="#"]');
        if (!link) {
            return;
        }
        if (link.hash
            && link.hash === document.location.hash
            && link.hostname === document.location.hostname
            && link.pathname === document.location.pathname
        ) {
            window.setTimeout(this._onHashChange, 0);
        }
    }

    _onHashChange() {
        const hash = document.location.hash.substr(1);
        if (hash.length) {
            const element = document.querySelector(`a[name="${hash}"],[id="${hash}"]`);
            if (element !== null && this._element.contains(element)) {
                const panels = this.panels;
                let targetPanel = null;
                for (let i = 0; i < panels.length; i++) {
                    if (panels[i].contains(element)) {
                        targetPanel = panels[i];
                        break;
                    }
                }
                if (targetPanel === null) {
                    let sibling = element.nextElementSibling;
                    while (sibling !== null && panels.indexOf(sibling) === -1) {
                        sibling = sibling.nextElementSibling;
                    }
                    targetPanel = sibling;
                }
                if (targetPanel !== null) {
                    this.activePanel = targetPanel;
                    window.setTimeout(() => {
                        element.scrollIntoView(true);
                    }, 10);
                }
            }
        }
    }
}
